import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import type {
  CraftType,
  CraftingInnerTabType,
  GatheringType,
  MainTabType,
  SkillTierIndex,
} from '@/types'

export const mainTabAtom = atom<MainTabType>('crafting')

export const selectedCraftAtom = atomWithStorage<CraftType>('xi-craft:selectedCraft', 'woodworking')

export const selectedTierAtom = atomWithStorage<SkillTierIndex | null>('xi-craft:selectedTier', 0)

export const selectedCraftingInnerTabAtom = atomWithStorage<CraftingInnerTabType>(
  'xi-craft:selectedCraftingInnerTab',
  'synthesis'
)

export const itemSearchQueryAtom = atom<string>('')

export const debouncedSearchQueryAtom = atom<string>('')

export const selectedGatheringAtom = atomWithStorage<GatheringType>(
  'xi-craft:selectedGathering',
  'mining'
)

export const gatheringSidebarModeAtom = atom<'area' | 'item'>('area')

export const selectedGatheringAreaAtom = atom<string | null>(null)

export const selectedGatheringItemAtom = atom<string | null>(null)
